<template>
  <section class="p-4 border w-full flex items-center justify-center text-xl">
    Select a maneuver to get started
  </section>
</template>
